import Wire from './Wire';

export default Wire;
